// Libraries
import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunk from 'redux-thunk';

// State
import { reducer } from 'state';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  combineReducers({ ...reducer }),
  composeEnhancers(applyMiddleware(thunk))
);

export default store;
